:host {
  display: block;
  line-height: 1;
}
